import { render, staticRenderFns } from "./StatusBar.vue?vue&type=template&id=28c5786f&scoped=true"
import script from "./StatusBar.vue?vue&type=script&lang=js"
export * from "./StatusBar.vue?vue&type=script&lang=js"
import style0 from "./StatusBar.vue?vue&type=style&index=0&id=28c5786f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c5786f",
  null
  
)

export default component.exports